/** Strips an "@domain" suffix off a V1/AD username, e.g. for MSAL-style emails. */
export function shortUsername(userid: string | null | undefined): string {
  if (!userid) return '';
  const at = userid.indexOf('@');
  return at === -1 ? userid : userid.slice(0, at);
}

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const SHORT_DATE_FORMAT: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric' };

/** Renders a history timestamp as a short relative label ("15m ago", "May 3"). */
export function formatRelativeDate(dateString: string, now: Date): string {
  if (!dateString) return '';
  const then = new Date(dateString);
  if (Number.isNaN(then.getTime())) return '';

  const diffMs = now.getTime() - then.getTime();
  if (diffMs < HOUR) return `${Math.max(0, Math.round(diffMs / MINUTE))}m ago`;
  if (diffMs < DAY) return `${Math.round(diffMs / HOUR)}h ago`;
  if (diffMs < 7 * DAY) return `${Math.round(diffMs / DAY)} days ago`;
  return then.toLocaleDateString('en-US', SHORT_DATE_FORMAT);
}
